// extracted by mini-css-extract-plugin
export default {"nav_link_bottom":"SocialLinks_nav_link_bottom__4wNa4","selected":"SocialLinks_selected__xDjut"};